import { Footer2022, Intro2022 } from '../components';
import { use2022Page } from '../shared';

const JudgesCriteria2022Zh = () => {
  use2022Page({ cate: 'judges_criteria', lang: 'zh', title: '2022智慧生活夥伴大獎 - 評審準則' });
  return (
    <div className="slpa2022-root">
      <Intro2022 lang="zh" />
      <section id="LeadIn"><div className="wave_bg"><img src="/2022/images/judgebg-01.png" alt="" /></div></section>
      <section id="JudgesCriteria"><div className="JudgesCriteria_info"><div className="JudgesCriteria_Title">評審準則</div><div className="JudgesCriteria_TitleLine"><div className="JudgesCriteria_TitleLineDot"><img src="/2022/images/linedot.png" alt="" /></div></div><div className="AwardCriteria_Table"><div className="AwardCriteria_Details"><p>創新和創意</p><p>15%</p></div><div className="AwardCriteria_Details"><p>功能和人體工學</p><p>15%</p></div><div className="AwardCriteria_Details"><p>品質</p><p>15%</p></div><div className="AwardCriteria_Details"><p>裨益和影響</p><p>20%</p></div><div className="AwardCriteria_Details"><p>市場潛力/表現</p><p>20%</p></div><div className="AwardCriteria_Details"><p>生態兼容性</p><p>15%</p></div></div></div></section>
      <Footer2022 lang="zh" />
    </div>
  );
};

export default JudgesCriteria2022Zh;

